import jQuery from 'jquery';

export const initCheckoutSteps = () => {
	var step2 = document.getElementById('checkout-step-2');
	var step3 = document.getElementById('checkout-step-3');
	var step4 = document.getElementById('checkout-step-4');

	if (!step2 || !step3) return;

	var scrollToTop = function () {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	function updateBreadcrumbs(stepName) {
		var currentSpan = document.querySelector('.elementor-widget-breadcrumbs .elementor-breadcrumbs__item-current') ||
			document.querySelector('.yoast-breadcrumb .breadcrumb_last') ||
			document.querySelector('#breadcrumbs .breadcrumb_last');

		if (currentSpan) {
			currentSpan.textContent = stepName;
		}
	}

	var originalMetaDesc = (function () {
		var el = document.querySelector('meta[name="description"]');
		return el ? (el.getAttribute('content') || '') : '';
	})();

	function updateMetaDescription(stepNumber) {
		var descriptions = {
			2: originalMetaDesc,
			3: 'Controleer je inschrijving \u2714 Bekijk training en gegevens \u2714 Bevestig eenvoudig \u2714 Ontvang snel een bevestiging en praktische info',
			4: 'Rond je inschrijving af \u2714 Betaal veilig en eenvoudig \u2714 Bevestig je plek \u2714 Ontvang direct een bevestiging en praktische informatie',
			5: 'Bedankt voor je inschrijving \u2714 We nemen contact met je op \u2714 Ontvang praktische info \u2714 Bekijk ook andere trainingen en programma\u2019s'
		};

		var content = descriptions[stepNumber];
		if (content === undefined || content === null) return;

		var metaDesc = document.querySelector('meta[name="description"]');
		if (!metaDesc) {
			metaDesc = document.createElement('meta');
			metaDesc.name = 'description';
			document.head.appendChild(metaDesc);
		}
		metaDesc.setAttribute('content', content);
	}

	function updatePageTitle(stepNumber) {
		var titles = {
			2: 'Stap 2 Inschrijven | Jouw gegevens',
			3: 'Stap 3 Inschrijven | Controle en bevestiging',
			4: 'Stap 4 Inschrijven | Betalen en afronden',
			5: 'Inschrijving ontvangen | Ken je Kracht'
		};
		if (titles[stepNumber]) {
			document.title = titles[stepNumber];
		}
		updateMetaDescription(stepNumber);
	}

	function updateStepHeadingState() {
		var isStep3 = step3.style.display !== 'none';
		var isStep4 = step4 && step4.style.display !== 'none';
		var activeStep = isStep4 ? 4 : (isStep3 ? 3 : 2);

		var stepConfigs = [
			{ step: 2, el: step2 },
			{ step: 3, el: step3 }
		];
		if (step4) {
			stepConfigs.push({ step: 4, el: step4 });
		}

		stepConfigs.forEach(function (config) {
			var wrapperTitle = config.el.querySelector('.wrapper-title');
			if (!wrapperTitle) return;

			var heading = wrapperTitle.querySelector('.step-title-h1, h1, h2, div');
			if (!heading) return;

			if (config.step === activeStep) {
				if (heading.tagName !== 'H1') {
					var h1 = document.createElement('h1');
					if (heading.id) h1.id = heading.id;
					h1.className = 'step-title-h1';
					h1.innerHTML = heading.innerHTML;
					heading.parentNode.replaceChild(h1, heading);
				}
			} else {
				if (heading.tagName !== 'DIV') {
					var div = document.createElement('div');
					if (heading.id) div.id = heading.id;
					div.className = 'step-title-h1 step-h1-inactive';
					div.innerHTML = heading.innerHTML;
					heading.parentNode.replaceChild(div, heading);
				}
			}
		});
	}

	// ── Step 2 validation helpers ────────────────────────────────────────────

	var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	var PHONE_REGEX = /^[+\d][\d\s\-().]{6,}$/;

	function getField(id) {
		return document.getElementById(id);
	}

	function showError(fieldEl, message) {
		var wrapper = fieldEl.closest('.form-row') || fieldEl.parentElement;
		wrapper.classList.add('woocommerce-invalid');

		// Remove any existing error
		var existing = wrapper.querySelector('.checkout-field-error');
		if (existing) existing.remove();

		var span = document.createElement('span');
		span.className = 'checkout-field-error';
		span.style.cssText = 'display:block;color:#e2401c;margin-top:4px;';
		span.textContent = message;
		wrapper.appendChild(span);
	}

	function clearError(fieldEl) {
		var wrapper = fieldEl.closest('.form-row') || fieldEl.parentElement;
		wrapper.classList.remove('woocommerce-invalid');
		var existing = wrapper.querySelector('.checkout-field-error');
		if (existing) existing.remove();
	}

	function validateStep2() {
		var isValid = true;
		var firstInvalid = null;

		// Required text fields: [id, label]
		var requiredFields = [
			['billing_company', 'Bedrijfsnaam is verplicht'],
			['billing_first_name', 'Voornaam is verplicht'],
			['billing_last_name', 'Achternaam is verplicht'],
			['billing_address_1', 'Adres is verplicht'],
			['billing_city', 'Stad is verplicht'],
			['billing_functie', 'Functie is verplicht'],
			['billing_factuuradres', 'Factuuradres is verplicht'],
			['billing_motivatie', 'Motivatie is verplicht'],
		];

		requiredFields.forEach(function (pair) {
			var el = getField(pair[0]);
			if (!el) return;

			var wrapper = el.closest('.form-row') || el.parentElement;
			var isRequired = wrapper && wrapper.classList.contains('validate-required');

			if (isRequired && !el.value.trim()) {
				showError(el, pair[1]);
				isValid = false;
				if (!firstInvalid) firstInvalid = el;
			} else {
				clearError(el);
			}
		});

		// Postcode – required + format
		var postcodeEl = getField('billing_postcode');
		if (postcodeEl) {
			var wrapper = postcodeEl.closest('.form-row') || postcodeEl.parentElement;
			var isRequired = wrapper && wrapper.classList.contains('validate-required');
			var val = postcodeEl.value.trim();
			var DUTCH_POSTCODE_REGEX = /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/;

			if (isRequired && !val) {
				showError(postcodeEl, 'Postcode is verplicht');
				isValid = false;
				if (!firstInvalid) firstInvalid = postcodeEl;
			} else if (val && !DUTCH_POSTCODE_REGEX.test(val)) {
				showError(postcodeEl, 'Vul een geldige postcode in (bijv. 1234 AB)');
				isValid = false;
				if (!firstInvalid) firstInvalid = postcodeEl;
			} else {
				clearError(postcodeEl);
			}
		}

		// Email fields (billing_email, billing_contact_email) – required + format
		['billing_email', 'billing_contact_email'].forEach(function (id) {
			var emailEl = getField(id);
			if (!emailEl) return;

			var wrapper = emailEl.closest('.form-row') || emailEl.parentElement;
			var isRequired = wrapper && wrapper.classList.contains('validate-required');
			var val = emailEl.value.trim();

			if (isRequired && !val) {
				showError(emailEl, 'E-mailadres is verplicht');
				isValid = false;
				if (!firstInvalid) firstInvalid = emailEl;
			} else if (val && !EMAIL_REGEX.test(val)) {
				showError(emailEl, 'Vul een geldig e-mailadres in');
				isValid = false;
				if (!firstInvalid) firstInvalid = emailEl;
			} else {
				clearError(emailEl);
			}
		});

		// Phone fields (billing_phone, billing_contact_phone) – required + format
		['billing_phone', 'billing_contact_phone'].forEach(function (id) {
			var phoneEl = getField(id);
			if (!phoneEl) return;

			var wrapper = phoneEl.closest('.form-row') || phoneEl.parentElement;
			var isRequired = wrapper && wrapper.classList.contains('validate-required');
			var val = phoneEl.value.trim();

			if (isRequired && !val) {
				showError(phoneEl, 'Telefoonnummer is verplicht');
				isValid = false;
				if (!firstInvalid) firstInvalid = phoneEl;
			} else if (val && !PHONE_REGEX.test(val)) {
				showError(
					phoneEl,
					'Vul een geldig telefoonnummer in (bijv. +31612345678)',
				);
				isValid = false;
				if (!firstInvalid) firstInvalid = phoneEl;
			} else {
				clearError(phoneEl);
			}
		});

		// Scroll to first invalid field
		if (firstInvalid) {
			firstInvalid.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
			firstInvalid.focus();
		}

		return isValid;
	}

	// Clear per-field error on input so feedback is immediate
	[
		'billing_company',
		'billing_first_name',
		'billing_last_name',
		'billing_email',
		'billing_phone',
		'billing_contact_email',
		'billing_contact_phone',
		'billing_address_1',
		'billing_postcode',
		'billing_city',
		'billing_functie',
		'billing_factuuradres',
		'billing_factuurgegevens',
		'billing_motivatie',
	].forEach(function (id) {
		var el = getField(id);
		if (el) {
			el.addEventListener('input', function () {
				clearError(el);
			});
			el.addEventListener('change', function () {
				clearError(el);
			});
		}
	});

	// ── btn-next-step-3 (Step 2 → Step 3) ───────────────────────────────────

	var btnNext3 = document.getElementById('btn-next-step-3');
	if (btnNext3) {
		btnNext3.addEventListener('click', function () {
			if (!validateStep2()) return; // Block navigation when invalid

			step2.style.display = 'none';
			step3.style.display = 'block';
			scrollToTop();
			if (window.history && window.history.pushState) {
				window.history.pushState({ step: 3 }, '', '/inschrijven-stap-3/');
			}
			updateBreadcrumbs('Controle');
			updatePageTitle(3);
			updateStepHeadingState();

			var wrapper = document.querySelector('.checkout-layout-wrapper');
			if (wrapper) {
				wrapper.classList.remove('is-step-4');
				wrapper.classList.add('is-step-3');
			}

			// Populate custom Step 3 review fields
			var voornaam = getField('billing_first_name');
			var achternaam = getField('billing_last_name');
			var contactEmail = getField('billing_contact_email');
			var email = (contactEmail && contactEmail.value.trim()) ? contactEmail : getField('billing_email');
			var contactPhone = getField('billing_contact_phone');
			var telefoon = (contactPhone && contactPhone.value.trim()) ? contactPhone : getField('billing_phone');
			var straat = getField('billing_address_1');
			var apartment = getField('billing_address_2');
			var postcode = getField('billing_postcode');
			var stad = getField('billing_city');
			var landSelect = getField('billing_country');
			var land = '';
			if (landSelect) {
				if (landSelect.options && landSelect.options.length > 0 && landSelect.selectedIndex >= 0) {
					land = landSelect.options[landSelect.selectedIndex].text;
				} else {
					land = landSelect.value || '';
				}
			}

			if (document.getElementById('review-voornaam')) {
				document.getElementById('review-voornaam').innerText = voornaam
					? voornaam.value
					: '';
				document.getElementById('review-achternaam').innerText =
					achternaam ? achternaam.value : '';
				document.getElementById('review-email').innerText = email
					? email.value
					: '';
				document.getElementById('review-telefoon').innerText = telefoon
					? telefoon.value
					: '';

				var adresParts = [];
				if (straat && straat.value) adresParts.push(straat.value);
				if (apartment && apartment.value) adresParts.push(apartment.value);
				if (postcode && postcode.value) adresParts.push(postcode.value);
				if (stad && stad.value) adresParts.push(stad.value);
				if (land) adresParts.push(land);
				document.getElementById('review-adres').innerText =
					adresParts.join(', ');
			}

			// Trigger update_checkout when moving to order overview
			if (typeof jQuery !== 'undefined') {
				jQuery(document.body).trigger('update_checkout');
			}
		});
	}

	var btnPrev2 = document.getElementById('btn-prev-step-2');
	if (btnPrev2) {
		btnPrev2.addEventListener('click', function () {
			step3.style.display = 'none';
			step2.style.display = 'block';
			scrollToTop();
			if (window.history && window.history.pushState) {
				window.history.pushState({ step: 2 }, '', '/inschrijven-stap-2/');
			}
			updateBreadcrumbs('Gegevens');
			updatePageTitle(2);
			updateStepHeadingState();
		});
	}

	var btnEditGegevens = document.getElementById('btn-edit-gegevens');
	if (btnEditGegevens) {
		btnEditGegevens.addEventListener('click', function () {
			step3.style.display = 'none';
			step2.style.display = 'block';
			scrollToTop();
			if (window.history && window.history.pushState) {
				window.history.pushState({ step: 2 }, '', '/inschrijven-stap-2/');
			}
			updateBreadcrumbs('Gegevens');
			updatePageTitle(2);
			updateStepHeadingState();

			var wrapper = document.querySelector('.checkout-layout-wrapper');
			if (wrapper) wrapper.classList.remove('is-step-3');
		});
	}

	var btnEditTraining = document.getElementById('btn-edit-training');
	if (btnEditTraining) {
		btnEditTraining.addEventListener('click', function () {
			window.location.href = '/inschrijven-stap-1/';
		});
	}

	var btnNext4 = document.getElementById('btn-next-step-4');
	if (btnNext4) {
		btnNext4.addEventListener('click', function () {
			step3.style.display = 'none';
			step4.style.display = 'block';
			scrollToTop();
			if (window.history && window.history.pushState) {
				window.history.pushState({ step: 4 }, '', '/inschrijven-stap-4/');
			}
			updateBreadcrumbs('Betaling');
			updatePageTitle(4);
			updateStepHeadingState();

			// Expand main content to 100% via CSS modifier
			var wrapper = document.querySelector('.checkout-layout-wrapper');
			if (wrapper) {
				wrapper.classList.remove('is-step-3');
				wrapper.classList.add('is-step-4');
			}

			if (typeof jQuery !== 'undefined') {
				// Ensure stripe/payment gateway is fully mounted/updated
				jQuery(document.body).trigger('update_checkout');
			}
		});
	}

	var btnPrev3 = document.getElementById('btn-prev-step-3');
	if (btnPrev3) {
		btnPrev3.addEventListener('click', function () {
			step4.style.display = 'none';
			step3.style.display = 'block';
			scrollToTop();
			if (window.history && window.history.pushState) {
				window.history.pushState({ step: 3 }, '', '/inschrijven-stap-3/');
			}
			updateBreadcrumbs('Controle');
			updatePageTitle(3);
			updateStepHeadingState();

			// Restore 70/30 layout
			var wrapper = document.querySelector('.checkout-layout-wrapper');
			if (wrapper) {
				wrapper.classList.remove('is-step-4');
				wrapper.classList.add('is-step-3');
			}
		});
	}

	var btnFakePlaceOrder = document.getElementById('btn-fake-place-order');
	if (btnFakePlaceOrder) {
		btnFakePlaceOrder.addEventListener('click', function () {
			var realPlaceOrderBtn = document.getElementById('place_order');
			if (!realPlaceOrderBtn) return;

			// Show loading state on the fake button
			var originalHTML = btnFakePlaceOrder.innerHTML;
			btnFakePlaceOrder.disabled = true;
			btnFakePlaceOrder.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;">Verwerken...</span>';

			// IMPORTANT: Use window.jQuery (WordPress's global jQuery), NOT the
			// bundled webpack module. WooCommerce binds its checkout events to
			// window.jQuery; using the bundled copy fires/listens on a different bus.
			var wpjQuery = window.jQuery;
			if (typeof wpjQuery !== 'undefined') {
				// Use jQuery trigger so WooCommerce's jQuery-bound handler fires
				// correctly (native .click() can bypass jQuery's e.preventDefault()
				// and cause a full-page POST instead of AJAX submission)
				wpjQuery(realPlaceOrderBtn).trigger('click');
			} else {
				// Fallback: native click (may not redirect on all environments)
				realPlaceOrderBtn.click();
			}
		});
	}

	// ── Global WooCommerce Checkout Error Listener ─────────────────────────────
	// Listen for checkout_error event to re-enable place order button and,
	// if the error relates to Step 2 fields, automatically redirect back to Step 2.
	var wpjQuery = window.jQuery;
	if (typeof wpjQuery !== 'undefined') {
		wpjQuery(document.body).on('checkout_error', function () {
			if (btnFakePlaceOrder) {
				btnFakePlaceOrder.disabled = false;
				// Restore original inner HTML if available or default label
				var placeOrderText = 'Bestelling plaatsen';
				if (document.querySelector('.custom-incompany-form')) {
					placeOrderText = 'Factuur verzenden';
				}
				btnFakePlaceOrder.innerHTML = placeOrderText;
			}

			setTimeout(function () {
				var noticeGroup = document.querySelector('.woocommerce-NoticeGroup-checkout, .woocommerce-error');
				var noticeText = noticeGroup ? noticeGroup.textContent.toLowerCase() : '';

				var step2Invalid = step2.querySelector('.woocommerce-invalid, .checkout-field-error');

				var step2Keywords = [
					'billing', 'postcode', 'zip', 'email', 'phone', 'telefoon',
					'adres', 'address', 'city', 'stad', 'voornaam', 'first name',
					'achternaam', 'last name', 'company', 'bedrijfsnaam', 'motivatie',
					'functie', 'factuuradres', 'factuurgegevens'
				];

				var isStep2Error = false;
				for (var i = 0; i < step2Keywords.length; i++) {
					if (noticeText.indexOf(step2Keywords[i]) !== -1) {
						isStep2Error = true;
						break;
					}
				}

				// Exclude step 4 incompany invoice specific fields
				if (noticeText.indexOf('incompany_') !== -1 || noticeText.indexOf('btw') !== -1 || noticeText.indexOf('factuur e-mailadres') !== -1) {
					isStep2Error = false;
				}

				if (step2Invalid || isStep2Error) {
					step3.style.display = 'none';
					if (step4) step4.style.display = 'none';
					step2.style.display = 'block';

					var wrapper = document.querySelector('.checkout-layout-wrapper');
					if (wrapper) {
						wrapper.classList.remove('is-step-3', 'is-step-4');
					}

					updateBreadcrumbs('Gegevens');
					updateStepHeadingState();
					if (window.history && window.history.pushState) {
						window.history.pushState({ step: 2 }, '', '/inschrijven-stap-2/');
					}

					// Move error notice block into Step 2 header so it's top visible
					if (noticeGroup) {
						var step2Header = step2.querySelector('.wrapper-title') || step2;
						step2Header.insertAdjacentElement('afterend', noticeGroup);
					}

					// Highlight specific field if notice text indicates field name
					if (noticeText.indexOf('postcode') !== -1 || noticeText.indexOf('zip') !== -1) {
						var pcEl = getField('billing_postcode');
						if (pcEl) showError(pcEl, 'Vul een geldige postcode in (bijv. 1234 AB)');
					}
					if (noticeText.indexOf('email') !== -1 || noticeText.indexOf('e-mail') !== -1) {
						var emEl = getField('billing_email') || getField('billing_contact_email');
						if (emEl) showError(emEl, 'Vul een geldig e-mailadres in');
					}

					// Scroll to first invalid field in Step 2
					var firstErrorField = step2.querySelector('.woocommerce-invalid input, .woocommerce-invalid textarea, .checkout-field-error') || noticeGroup || step2;
					if (firstErrorField && firstErrorField.scrollIntoView) {
						firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
						if (firstErrorField.focus) firstErrorField.focus();
					} else {
						scrollToTop();
					}
				}
			}, 100);
		});
	}

	updateStepHeadingState();

	// Handle Step 5 (Order Received / Bevestiging)
	if (document.querySelector('.woocommerce-order-received') || window.location.href.indexOf('inschrijven-bevestiging') !== -1 || window.location.href.indexOf('order-received') !== -1) {
		updateBreadcrumbs('Bevestiging');
		updatePageTitle(5);
	}
};

document.addEventListener('DOMContentLoaded', initCheckoutSteps);
